import { createInstance } from '@jonkoops/matomo-tracker-react'

export const matomoInstance = createInstance({
    urlBase: 'https://d1kwyyyhoyp4aj.cloudfront.net/',
    siteId: 1,
})